import React from "react"
import { translations } from "../../utils/Translation/staticTranslation"

const lang = localStorage.getItem("language") || "ar"
const currentLanguage = translations[lang]?.DashboardSuperAdmin

export const StatBox = ({ color, value, title }) => {
  return (
    <div
      style={{ padding: "24px", backgroundColor: color }}
      className="col-4 border-radius-5"
    >
      <div>
        <p className="text-FFFFFF text-36 font-700">{value}</p>
        <p className="text-FFFFFF text-16">{title}</p>
      </div>
    </div>
  )
}

export const withStats = (WrappedComponent) => {
  return function EnhancedComponent({ highest_role, merchantsStats }) {
    if (highest_role !== "SUPERADMIN") return null // Only render for SUPERADMIN

    const statsData = [
      {
        color: "#6740B4",
        value: merchantsStats.total_merchants,
        title: currentLanguage?.new_merchants,
      },
      {
        color: "#479F4C",
        value: merchantsStats.active_merchants,
        title: currentLanguage?.active_merchants,
      },
      {
        color: "#F98C25",
        value: merchantsStats.inactive_merchants,
        title: currentLanguage?.inactive_merchants,
      },
    ]

    return (
      <div className="d-flex" style={{ maxWidth: "84vw", gap: "10px" }}>
        {statsData.map((stat, index) => (
          <WrappedComponent key={index} {...stat} />
        ))}
      </div>
    )
  }
}
